import { render, staticRenderFns } from "./apn.vue?vue&type=template&id=2f8285d1&scoped=true"
import script from "./apn.vue?vue&type=script&lang=js"
export * from "./apn.vue?vue&type=script&lang=js"
import style0 from "./apn.vue?vue&type=style&index=0&id=2f8285d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8285d1",
  null
  
)

export default component.exports